import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";

// Custom.
import Layout from "containers/Layout/Layout";
import Form from "@vocollege/components/dist/Form";
import I18n from "@vocollege/app/dist/modules/Services/I18n";
import {
  GET_BOOK,
  UPDATE_BOOK,
  CREATE_BOOK,
} from "@vocollege/app/dist/modules/VoApi/graphql";
import VoAuth from "@vocollege/app/dist/modules/VoAuth";
import Utils from "services/Utils";

export default function PageEdit() {
  const router = useParams<any>();
  const navigate = useNavigate();

  // Methods.

  const getInitialState = () => {
    const initialState: { [key: string]: any } = {
      id: 0,
      title: "",
      body: "",
      status: 0,
      access: [],
      author: null,
      parent: null,
      tags: [],
      attachments: [],
      roles: [],
      groupRoles: [],
    };
    const { id } = router;
    if (id && id === "create") {
      initialState.author = {
        id: VoAuth.currentUser.id,
        name: VoAuth.currentUser.name,
        type: "user",
      };
    }
    return initialState;
  };

  const handleRedirect = (state: any) => {
    if (Utils.redirect(state)) {
      toast.info(I18n.get.form.messages.redirecting, { autoClose: 0 });
    } else {
      navigate("/content/books");
    }
  };

  return (
    <Layout>
      <Form
        // client={client}
        tabs={[
          {
            key: "content",
            label: I18n.get.misc.content,
            fields: [
              {
                name: "title",
                label: I18n.get.form.labels.title,
                type: "text",
                required: true,
                grid: {
                  xs: 12,
                  md: 9,
                },
                validation: {
                  required: true,
                },
              },
              {
                name: "status",
                label: I18n.get.status.published,
                type: "switch",
                required: true,
                grid: {
                  xs: 12,
                  md: 3,
                },
              },
              {
                name: "parent",
                label: I18n.get.book.labels.parent,
                type: "entity_field",
                grid: {
                  xs: 12,
                },
                params: {
                  dialog: {
                    types: ["book"],
                  },
                },
              },
              {
                name: "body",
                label: I18n.get.form.labels.body,
                type: "editor",
                grid: {
                  xs: 12,
                },
              },
            ],
          },
          {
            key: "extra",
            label: I18n.get.misc.extra,
            fields: [
              {
                name: "tags",
                label: I18n.get.tag.labels.tags,
                type: "tags_field",
                grid: {
                  xs: 12,
                },
                params: {
                  dialog: {
                    types: ["tag"],
                    addNew: true,
                  },
                },
              },
              {
                name: "author",
                label: I18n.get.misc.author,
                type: "entity_field",
                grid: {
                  xs: 12,
                },
                params: {
                  dialog: {
                    types: ["user"],
                  },
                  fields: {
                    user: {
                      title: "name",
                    },
                  },
                },
              },
            ],
          },
          {
            key: "attachments",
            label: I18n.get.misc.attachments,
            fields: [
              {
                name: "attachments",
                label: I18n.get.misc.attachments,
                type: "content_list",
                grid: {
                  xs: 12,
                },
                params: {
                  contentType: "file",
                },
              },
            ],
          },
          {
            key: "roles",
            label: I18n.get.misc.roles,
            fields: [
              {
                name: "access",
                label: I18n.get.book.labels.grantAccess,
                type: "checkboxes",
                grid: {
                  xs: 12,
                },
                params: {
                  availableValues: I18n.get.book.accessValues,
                  row: true,
                },
              },
              {
                name: "roles",
                label: I18n.get.misc.roles,
                type: "content_list",
                grid: {
                  xs: 12,
                },
                params: {
                  renderItemTitle: (item: any) => item.title || item.label,
                  fields: {
                    role: {
                      title: "label",
                    },
                  },
                  dialog: {
                    types: ["role"],
                  },
                },
              },
            ],
          },
          {
            key: "groupRoles",
            label: I18n.get.group.labels.groupRoles,
            fields: [
              {
                name: "groupRoles",
                label: I18n.get.group.labels.groupRoles,
                type: "content_list",
                grid: {
                  xs: 12,
                },
                params: {
                  renderItemTitle: (item: any) => item.title || item.label,
                  fields: {
                    role: {
                      title: "label",
                    },
                  },
                  dialog: {
                    types: ["group_role"],
                  },
                },
              },
            ],
          },
        ]}
        labels={{
          loading: I18n.get.form.labels.loadingContent,
          create: I18n.get.book.labels.createBook,
          created: I18n.get.book.messages.bookSaved,
          updated: I18n.get.book.messages.bookSaved,
          deleted: I18n.get.book.messages.bookDeleted,
          fieldRequired: I18n.get.form.errors.required,
        }}
        operations={{
          category: "book",
          get: GET_BOOK,
          create: CREATE_BOOK,
          update: UPDATE_BOOK,
        }}
        // paths={{
        //   back: "/content/pages",
        // }}
        initialState={getInitialState()}
        pageTitleField="title"
        classes={{
          paper: "vo-global__content-with-toolbar",
          toolbar: "vo-global__content-toolbar",
        }}
        onComplete={handleRedirect}
        onCancel={handleRedirect}
      />
    </Layout>
  );
}
